import React from "react"

function Footer({ isMobileDevice  }) {
    return (
        <footer className={isMobileDevice ? "mobile" : "desktop"}>
            <p>Coded with 💖 by 
                <a href="https://github.com/VincentLeV" target="_blank" rel="noreferrer"> Vincent Le </a>  
                2021 &copy;
            </p>
            <p>Final project for Front End Development course by 
                <a href="https://socialhackersacademy.org/" target="_blank" rel="noreferrer"> Social Hackers Academy</a>
            </p>
        </footer>
    )
}

export default Footer
